module.exports = __webpack_public_path__ + "static/media/bca2.ff969bbe.png";